import { domainUrl } from '../constants';

export const API_GET_POST_GALLERIES = `${domainUrl}galleries`;
export const API_UPDATE_DELETE_GALLERY = `${domainUrl}galleries/{id}`;
